import { StyleSheet } from "react-native";
import { Theme } from "../../theme-provider";

const listContentStyle = (theme: Theme) => StyleSheet.create({
    container: {
        flexDirection: 'row',
        paddingVertical: theme.spacing.half,
        paddingLeft: theme.spacing.half,
        paddingRight: theme.spacing.half,
        height: theme.units.base * 6.4,
        alignContent: 'center',
    },
    categoryIcon: {
        aspectRatio: 1 / 1,
        height: '100%',
        marginRight: theme.spacing.half,
        color: theme.color.mapIcons,
    },
    content: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
    },
    title: {
        fontSize: theme.fontSize.medium,
        color: theme.color.textPrimary,
    },
    subtitle: {
        fontSize: theme.fontSize.small,
        color: theme.color.textPrimary,
        opacity: 1,
        flexWrap: 'nowrap',
        paddingRight:  theme.spacing.half,
    },
    length: {
        fontSize: theme.fontSize.medium,
        color: theme.color.textSecondary,
    },
    status: {
        fontSize: theme.fontSize.small,
        color: theme.color.textSecondary,
        textAlign: 'right',
    },
    difficultyIcon: {
        height: theme.iconSize.medium,
        width: theme.iconSize.medium,
        marginRight: theme.spacing.half,
    },
    count: {
        marginLeft: 'auto',
        fontSize: theme.fontSize.medium,
        color: theme.color.mapIcons,
    },
    flexRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    row: {
        justifyContent: 'space-between',
        marginBottom: theme.spacing.sliver,
    },
    nameWrapper: {
        width: '70%',
    },
});

export { listContentStyle };